export const GET_MEMBERSHIP_PLANS_REQUEST = 'GET_MEMBERSHIP_PLANS_REQUEST';
export const GET_MEMBERRHIP_PLANS_SUCCESS = 'GET_MEMBERSHIP_PLANS_SUCCESS';
export const GET_MEMBERSHIP_PLANS_FAILED = 'GET_MEMBERSHIP_PLANS_FAILED';

export const ADD_MEMBERSHIP_PLAN_REQUEST = 'ADD_MEMBERSHIP_PLAN_REQUEST';
export const ADD_MEMBERSHIP_PLAN_SUCCESS = 'ADD_MEMBERSHIP_PLAN_SUCCESS';
export const ADD_MEMBERSHIP_PLAN_FAILED = 'ADD_MEMBERHSIP_PLAN_FAILED';

export const UPDATE_MEMBERSHIP_PLAN_REQUEST = 'UPDATE_MEMBERSHIP_PLAN_REQUEST';
export const UPDATE_MEMBERSHIP_PLAN_SUCCESS = 'UPDATE_MEMBERSHIP_PLAN_SUCCESS';
export const UPDATE_MEMBERSHIP_PLAN_FAILED = 'UPDATE_MEMBERSHIP_PLAN_FAILED';

export const DELETE_MEMBERSHIP_PLAN_REQUEST = 'DELETE_MEMBERSHIP_PLAN_REQUEST';
export const DELETE_MEMBERSHIP_PLAN_SUCCESS = 'DELETE_MEMBERSHIP_PLAN_SUCCESS';
export const DELETE_MEMBERSHIP_PLAN_FAILED = 'DELETE_MEMBERSHIP_PLAN_FAILED';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/MembershipPlansActionTypes.js